import { paths } from "src/paths";

const LAST_ROUTE_KEY = "rich:last-dashboard-route";
const EXCLUDED_PATHS = [
  paths.dashboard.apts.newwindow,
  paths.dashboard.apts.pyeongNewwindow,
  paths.dashboard.analyze.newwindow,
  paths.dashboard.analyze.noteNewWindow,
  paths.dashboard.analyze.noteFolderWindow,
  paths.dashboard.regions.newwindow,
];

/** 사용자별 마지막 메뉴 저장 키를 만든다. */
const getUserRouteKey = (user) => {
  const userKey = user?.id ?? user?.userId ?? user?.email;
  return userKey == null ? null : `${LAST_ROUTE_KEY}:${userKey}`;
};

/** 새창 전용 화면을 제외한 일반 대시보드 메뉴인지 확인한다. */
export const isRememberableDashboardRoute = (route = "") => {
  if (typeof route !== "string") return false;
  const url = new URL(route, window.location.origin);
  const pathname = url.pathname;
  return pathname.startsWith("/dashboard/")
    && url.searchParams.get("menu") !== "false"
    && !EXCLUDED_PATHS.some((excluded) => pathname === excluded);
};

/** pathname과 탭 query를 마지막 대시보드 메뉴로 저장한다. */
export const saveLastDashboardRoute = (route, user) => {
  if (!isRememberableDashboardRoute(route)) return;
  window.localStorage.setItem(LAST_ROUTE_KEY, route);
  const userKey = getUserRouteKey(user);
  if (userKey) window.localStorage.setItem(userKey, route);
};

/** 사용자의 마지막 메뉴를 읽고 없거나 유효하지 않으면 기본 대시보드로 돌아간다. */
export const getLastDashboardRoute = (user) => {
  const userKey = getUserRouteKey(user);
  const route = (userKey && window.localStorage.getItem(userKey))
    || window.localStorage.getItem(LAST_ROUTE_KEY);
  return isRememberableDashboardRoute(route) ? route : paths.dashboard.index;
};

/** 직접 요청한 보호 URL이 있으면 우선하고, 일반 로그인은 마지막 메뉴로 이동한다. */
export const resolveDashboardLoginDestination = (returnTo, user) => {
  if (returnTo && returnTo !== "null") {
    const pathname = new URL(returnTo, window.location.origin).pathname;
    // 로그아웃 후 기본 로그인 링크가 붙이는 demo returnTo는 사용자 선택 메뉴가 아니다.
    if (pathname !== paths.dashboard.index && pathname !== "/dashboard") {
      return returnTo;
    }
  }
  return getLastDashboardRoute(user);
};
